






















import { Mutation } from 'vuex-class'
import moment from 'moment-timezone'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Nullable } from '@/types/general'
import { timeFormat, timeFromNow } from '@/util/Time'
import PStorage from '@/util/PStorage'
import { REVISION_VIEW } from '@/store/revision/constants'
import { Revision } from '@/store/revision/types'
import RevisionTitle from './RevisionTitle.vue'

@Component({ components: { RevisionTitle }, name: 'revision-list-item' })
export default class RevisionListItem extends Vue {
    /**
     * Used to re-render the time element
     */
    refreshNum: number = 0

    /**
     * Interval for refreshing the time element
     */
    refreshInterval: Nullable<NodeJS.Timer> = null

    /**
     * The revision to display
     */
    @Prop({ type: Object, required: true })
    revision!: Revision

    /**
     * Open a revision for viewing
     */
    @Mutation(REVISION_VIEW)
    viewRevision!: (revision: Nullable<Revision>) => Promise<void>

    /**
     * Get the formatted time
     */
    get time() {
        return timeFormat(this.revision.updatedAt)
    }

    mounted() {
        // refresh the 'from now' time every 60s
        this.refreshInterval = setInterval(() => {
            this.refreshNum += 1
        }, 60000)
    }

    destroyed() {
        // clear the refresh interval
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval)
        }
    }

    /**
     * Get the time from now (moment)
     */
    timeFromNow(time: string) {
        return timeFromNow(time)
    }

    /**
     * Open the current revision
     */
    view() {
        this.viewRevision(this.revision)
    }
}
